import $ from 'jquery';
import 'slick-slider';
// import 'bootstrap';
import './search';
import './navigation';

import { initTransactionsCarousel } from './transactions-slider';
import { initFrontPageSlider } from './frontpage-slider';
import { initPeopleSlider } from './people-slider';
import initTimeline from './timeline';
import { initExpertiseSlider } from './expertise-slider';
import { initTestimonialsSlider } from './testimonials-slider';
import initInsightsPageSlider from './insights-slider';
import initVideoIframeModule from './video-iframe-module';
import { showAllArticles } from './show-all-articles';
import accordion from './accordion';
import articlePeople from './article-people';
import videoPlay from './video';
import megaMenuSearch from './megamenu-search';
import languageBar from './language-bar';

$(() => {
  initFrontPageSlider();
  initTransactionsCarousel();
  initPeopleSlider();
  initTestimonialsSlider();
  initExpertiseSlider();
  initInsightsPageSlider();
  initVideoIframeModule();
  showAllArticles();
  accordion();
  articlePeople();
  megaMenuSearch();
  languageBar();
  initTimeline();
  videoPlay();
});

$(window).on('resize orientationchange', () => {
  const mql = window.matchMedia('(max-width: 1023.99px)');
  if (mql.matches) {
    initInsightsPageSlider();
  }
});
